export default __webpack_public_path__ + "static/media/FilterIcon.15b66d01.svg";